import * as React from "react";
import { forwardRef } from "react";
const SvgNote = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 14, height: 14, viewBox: "0 0 14 14", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1 1v12h8.4l.17-.153 3.272-3.272L13 9.4V1zm1.091 1.091h9.815v6.543H8.634v3.272H2.091zm7.634 7.634h1.4l-1.4 1.4z", "data-name": "icon_note" }));
const ForwardRef = forwardRef(SvgNote);
export { ForwardRef as ReactComponent };
